import { useEffect, useState } from "react";
import EnhancedTable from "../elementos/basicos/TablaCategoriasPublicacionesLista";
import { fetchCategoriasPublicacionFilters, fetchEliminarCategoriasPublicaciones, fetchActualizarCategoriasPublicaciones } from '../../peticiones_API/PeticionesCategoriasPublicaciones';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from "../elementos/basicos/Titulo";
import styled from 'styled-components';
import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';
import { MdBorderBottom } from "react-icons/md";

const GestorCategoriaPublicacionesDatos = () => {

    const location = useLocation();
    let params = new URLSearchParams(location.search);

    let paginaActual = parseInt(params.get("pagina")) || 1;
    let registrosPorPag = parseInt(params.get("registrosPorPag")) || 10;
    let busqueda = params.get("busqueda") || null;
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(true);
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();

    const [data, setData] = useState({
        meta: {},
        rows: []
    });

    const [selected, setSelected] = useState([]);
    const [eliminarTodoCategorias, setEliminarTodoCategorias] = useState({ atributo: 'visible', valor: null });
    const [eliminarCatSelect, setEliminarCatSelect] = useState({ atributo: 'visible', valor: null });

    const confirmDialog = ConfirmacionEliminar();

    useEffect(() => {
        async function fechtActualizarFiltros() {
            try {
                if (
                    eliminarTodoCategorias.valor === false ||
                    eliminarCatSelect.valor === false
                ) {

                    let mensaje = "";

                    if (eliminarTodoCategorias.valor === false || eliminarCatSelect.valor === false) {
                        mensaje = "eliminar";
                    }

                    const confirm = await confirmDialog.showAlert(mensaje, "categorias");

                    if (confirm) {
                        let categoriasActualizar = [];

                        if (eliminarTodoCategorias.valor === false) {

                            setEliminarTodoCategorias((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const publicacionesResponse = await fetchCategoriasPublicacionFilters(
                                paginaActual,
                                registrosPorPag,
                                busqueda,
                                ordenarColumna,
                                orden
                            );

                            publicacionesResponse.data.forEach((categoria) => {
                                categoriasActualizar.push(categoria.Id);
                            });

                            await fetchActualizarCategoriasPublicaciones(categoriasActualizar, eliminarTodoCategorias);
                            setSelected([]);
                        }

                        if (eliminarCatSelect.valor === false && selected.length !== 0) {

                            setEliminarCatSelect((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            categoriasActualizar = selected;

                            await fetchActualizarCategoriasPublicaciones(categoriasActualizar, eliminarCatSelect);
                            setSelected([]);
                        }

                        const publicacionesResponse = await fetchCategoriasPublicacionFilters(
                            paginaActual,
                            registrosPorPag,
                            busqueda,
                            ordenarColumna,
                            orden
                        );

                        const { data: publicacionesData, meta } = publicacionesResponse;

                        setData({
                            meta,
                            rows: formatData(publicacionesData),
                        });

                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    } else {

                        setEliminarTodoCategorias((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));

                        setEliminarCatSelect((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error al actualizar filtros:", error);
            }
        }

        if (
            eliminarTodoCategorias.valor === false ||
            eliminarCatSelect.valor === false
        ) {
            fechtActualizarFiltros();
        }

    }, [eliminarTodoCategorias, eliminarCatSelect, paginaActual, registrosPorPag, busqueda, ordenarColumna, orden]);



    useEffect(() => {
        const fetchPrincipal = async () => {
            try {
                setLoading(true);

                const page = paginaActual || 1;
                const perPage = registrosPorPag || 10;

                let urlParams = `?pagina=${page}&registrosPorPag=${perPage}`;
                if (busqueda) urlParams += `&busqueda=${busqueda}`;
                if (ordenarColumna) urlParams += `&ordenarColumna=${ordenarColumna}`;
                if (orden) urlParams += `&orden=${orden}`;

                navigate(`${urlPadre}${urlParams}`, { replace: true });

                const response = await fetchCategoriasPublicacionFilters(
                    page,
                    perPage,
                    busqueda,
                    ordenarColumna,
                    orden
                );

                const { data: responseData, meta } = response;

                setData({
                    meta,
                    rows: formatData(responseData),
                });

            } catch (error) {
                console.log("Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPrincipal();

    }, [paginaActual, registrosPorPag, busqueda, ordenarColumna, orden]);



    const formatData = (data) => {
        return data.map((row) => {
            return {
                id: row.Id ,
                categoria: row.categoria ? row.categoria : "-",
                descripcion: row.descripcion ? row.descripcion : "-",
                editar: row.Id
            };
        });
    };


    const header = [
        {
            id: 'categoria',
            numeric: false,
            disablePadding: true,
            label: 'Categoría',
        },
        {
            id: 'descripcion',
            numeric: false,
            disablePadding: true,
            label: 'Descripción',
        },
        {
            id: 'editar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];

    return (
        <>
            <CabeceraForm>
                <Titulo
                    texto="Categorías de las Publicaciones"
                    tituloTabla="true"
                />
            </CabeceraForm>

            <EnhancedTable
                data={data.rows}
                header={header}
                meta={data.meta}
                selected={selected}
                setSelected={setSelected}
                eliminarTodoCategorias={eliminarTodoCategorias}
                setEliminarTodoCategorias={setEliminarTodoCategorias}
                eliminarCatSelect={eliminarCatSelect}
                setEliminarCatSelect={setEliminarCatSelect}
                isLoading={loading}
            />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
`;

export default GestorCategoriaPublicacionesDatos;